import {
  GetAccountBidsBidStatusEnum,
  GetAccountBidsSortOrderEnum,
} from '@b-stock/auction-api-client'

/**
 * Deliberately larger than the `MAX_BID_ROWS` display cap so the outbid-first
 * re-sort sees the full closing-soonest window.
 */
export const DASHBOARD_BIDS_FETCH_LIMIT = 25

/**
 * Params for the buyer's open bids, closing soonest first — same shape My
 * Bids uses (see BidSearchProvider), so every consumer shares one deduped
 * cache entry. Kept in its own module (no `'use client'`) so both
 * useDashboardBids (client) and a server-side prefetch can import it — a
 * client-directive file's exports can't be called directly from a server
 * component, only rendered or passed as props.
 */
export const getDashboardBidsParams = (
  accountId: string | null | undefined
) => ({
  accountId: accountId ?? undefined,
  bidStatus: [
    GetAccountBidsBidStatusEnum.Winning,
    GetAccountBidsBidStatusEnum.Losing,
  ],
  // BidsSortBy.ClosingSoonest on the My Bids page.
  sortBy: 'auction.actualEndTime',
  sortOrder: GetAccountBidsSortOrderEnum.Asc,
  offset: 0,
  limit: DASHBOARD_BIDS_FETCH_LIMIT,
})
